import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {AppConfigurationService} from '../common/app-config/app-configuration.service';
import { AppMainRoutingModule } from './app-main-routing.module';
import {RouterModule} from '@angular/router';
import {AppMainComponent} from "../app-main/app-main.component";
import {TranslateModule} from "../common/translate/translate.module";
import {ClickableElementModule} from "../common/directives/clickable.element/clickable.element.module";
import {CommonComponentsModule} from "../common/components/common.components.module";
import {LanguageSelectionModule} from "../common/translate/language.selection.module";
import {CommonModule} from "@angular/common";
import {EnvInitializer} from "../common/services/environement.initializer";
import {HideWhenPopupOpenModule} from "../common/directives/hide.when.popup.open/hide.when.popup.open.module";

export function initConfigFactory(appConfigService: AppConfigurationService) {
	return () => appConfigService.loadConfig();
}

export function baseHrefFactory() {
	const baseResourceUrl = window['__patient_portal_global_vars__'].baseResourceUrl;
	if (baseResourceUrl === '/') {
		return baseResourceUrl;
	}
	const expectedBaseHref = baseResourceUrl.split('/')[1];
	const currentBaseHref = window.location.pathname.split('/')[1];
	if (expectedBaseHref.toLowerCase() === currentBaseHref.toLowerCase() && expectedBaseHref !== currentBaseHref) {
		// The two base hrefs are the same, but not the same case.
		// Redirect the user to the correct base href.
		const newLocation = window.location.href.replace(currentBaseHref, expectedBaseHref);
		window.location.replace(newLocation);
	}
	return '/' + expectedBaseHref + '/';
}

@NgModule({
	declarations: [
		AppMainComponent
	],
	imports: [
		CommonModule,
		HttpClientModule,
		AppMainRoutingModule,
		RouterModule,
		TranslateModule,
		ClickableElementModule,
		CommonComponentsModule,
		LanguageSelectionModule,
		HideWhenPopupOpenModule
	],
	providers: [
		EnvInitializer
	]
})
export class AppMainModule { }


